/**
 * @file useBookingPricing.hook.ts
 * @path apps/website/src/features/booking/hooks/useBookingPricing.hook.ts
 * @description
 * Selects the current pricing breakdown from the Zustand store.
 * The store recomputes pricing on every relevant state change, so this hook
 * simply exposes the cached result.
 */

import { useBookingStore, selectPricing } from "../booking.store";
import { PriceBreakdown } from "../pricing.util";
import { calculateTotalForAllBookings } from "../pricing.util";

export interface UseBookingPricingResult {
  pricing: PriceBreakdown;
  grandTotal: number;
}

export const useBookingPricing = (): UseBookingPricingResult => {
  const pricing = useBookingStore(selectPricing);
  const completedBookings = useBookingStore((s) => s.completedBookings);

  // grandTotal includes all saved bookings + current draft total
  const savedTotal = calculateTotalForAllBookings(completedBookings);
  const grandTotal = savedTotal + pricing.total;

  return { pricing, grandTotal };
};
